// extracted by mini-css-extract-plugin
module.exports = {"passcode":"DocumentPreview_passcode__nWJDK"};